import React, {FC} from 'react'

type MoneyDisplayProps = {
  primaryAmount?: number | string | null
  primaryCurrency?: string | null
  secondaryAmount?: number | string | null
  secondaryCurrency?: string | null
  exchangeRateDisplay?: string | null
  compact?: boolean
  sameCurrency?: boolean
  className?: string
}

const formatMoney = (amount?: number | string | null, currency?: string | null) => {
  if (amount == null || amount === '') {
    return null
  }
  const numeric = Number(amount)
  if (!Number.isFinite(numeric)) {
    return null
  }
  const code = String(currency ?? '').trim().toUpperCase()
  try {
    if (code) {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: code,
        maximumFractionDigits: 2,
      }).format(numeric)
    }
  } catch {
    // fall through to generic numeric rendering
  }
  return code
    ? `${code} ${numeric.toLocaleString('en-IN', {maximumFractionDigits: 2})}`
    : numeric.toLocaleString('en-IN', {maximumFractionDigits: 2})
}

const MoneyDisplay: FC<MoneyDisplayProps> = ({
  primaryAmount,
  primaryCurrency,
  secondaryAmount,
  secondaryCurrency,
  exchangeRateDisplay,
  compact = false,
  sameCurrency = false,
  className = '',
}) => {
  const primaryDisplay = formatMoney(primaryAmount, primaryCurrency)
  const hasSecondary = Number.isFinite(Number(secondaryAmount))
  const secondaryDisplay = hasSecondary ? formatMoney(secondaryAmount, secondaryCurrency) : null
  return (
    <div className={className}>
      {primaryDisplay ? <div className={`fw-bold text-dark ${compact ? 'fs-7' : 'fs-5'}`}>{primaryDisplay}</div> : null}
      {secondaryDisplay ? (
        <div className='text-muted fs-8'>
          {secondaryDisplay}
          {!sameCurrency && exchangeRateDisplay ? ` • ${exchangeRateDisplay}` : ''}
        </div>
      ) : exchangeRateDisplay && !sameCurrency ? (
        <div className='text-muted fs-8'>{exchangeRateDisplay}</div>
      ) : null}
    </div>
  )
}

export default MoneyDisplay
